import styled from "styled-components";
import { media } from "@nested/ui";

const HR = styled.hr`
  margin-top: 30px;
  margin-bottom: 30px;
  border: none;
  border-top: 1px solid #eee;
  ${media.tablet`
    margin-top: 40px;
    margin-bottom: 40px;
  `};
`;

export { HR };
